<script>
export default {
	data: () => {
		return {
			copyrightDate: new Date().getFullYear(),
			author: 'Alex Buzmion II',
		};
	},
};
</script>

<template>
	<div class="flex justify-center items-center text-center">
		<div
			class="font-general-regular text-lg text-ternary-dark dark:text-ternary-light"
		>
			&copy; {{ copyrightDate }}
			Developed by
			<span class="font-general-medium text-secondary-dark dark:text-secondary-light uppercase">
				{{ author }}
			</span>
		</div>
	</div>
</template>

<style lang="scss" scoped></style>
